
import { mapGetters } from 'vuex'
import reportCount from '@/mixins/report-count.js'
import { ToDecimal } from 'utils';
export default {
  mixins: [reportCount],
  data () {
    return {
      totalArr: {}
    }
  },
  computed: {
    ...mapGetters(['getAllGame']),

  },
  methods: {
    columns (gameid) {
      const list = this.getAllGame.find(it => it.gameid == gameid)
      let obj = {
        username: {
          title: '帐号',
          align: 'center',
          key: 'username',
          width: 120,
        },
        betisbuhuo: {
          title: '投注类别',
          align: 'center',
          key: 'betisbuhuo',
          width: 40,
          render: (h, params) => {
            let text = ''
            switch (params.row.betisbuhuo) {
              case 0:
                text = '一般'
                break;
              case 1:
                text = '自补'
                break;
              case 2:
                text = '文字'
                break;
              case 3:
                text = '手补'
                break;
            }

            return params.row.date !== '总计'
              ? h('span', text)
              : ''
          },
        },
        betcalid: {
          title: '注单ID',
          align: 'center',
          key: 'betcalid',
          width: 90,
        },
        bpname: {
          title: '盘口',
          align: 'center',
          key: 'bpname',
          width: 50,
        },
        gameid: {
          title: this.judgeExgame(Number(gameid)) ? '游戏名称' : '游戏项目',
          align: 'center',
          key: 'gameid',
          width: 120,
          render: (h, params) => {
            if (params.row.date !== '总计') {
              if (!this.getAllGame.length) return
              return h('p', !this.judgeExgame(Number(gameid)) ? list.gamename : params.row.gamename || this.getGamename(gameid))
            }
          },
        },
        deoddsrepname: {
          title: '投注选项',
          align: 'center',
          key: 'deoddsrepname',
          minWidth: 120,
          render: (h, params) => {
            return h('div', [
              h('span', { class: { 'mr-1': true } }, params.row.deoddsrepname),
              h('span', params.row.mark)
            ])
          },
        },
        date: {
          title: '日期/时间',
          align: 'center',
          key: 'date',
          totaltext: '总计',
          minWidth: 100,
        },
        period: {
          title: '期数',
          align: 'center',
          key: 'period',
          width: 100,
        },
        odds: {
          title: '赔率',
          align: 'center',
          key: 'odds',
          minWidth: 10,
          render: (h, params) => {
            if (!params.row.odds) return
            if ('odds2' in params.row) {
              let oddslist = params.row.odds2.split(',')
              let oddsArray = oddslist.map((it, i) => h('p', ToDecimal(it, 3) + `${oddslist.length - 1 != i ? ' /' : ''}`))
              return h('div', oddsArray)
            } else {
              return h('p', ToDecimal(params.row.odds, 3))
            }
          },
        },
        value: {
          title: '下注金额',
          align: 'center',
          key: 'value',
          total: true,
          minWidth: 60,
          render: (h, params) => this.renderColorAmount(h, params, 'value')
        },
        bonuswin: {
          title: '派彩金额',
          align: 'center',
          key: 'bonuswin',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'bonuswin')
        },
        win: {
          title: '派彩金额',
          align: 'center',
          key: 'win',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'win')
        },
        duishei: {
          title: '退水',
          align: 'center',
          key: 'duishei',
          width: 70,
          render: (h, params) => {
            return !this.checkFooterText(params.row.date) ? h('p', `${params.row.duishei > 0 ? params.row.duishei : 0}%`) : null
          }
        },
        bonus: {
          title: '奖金',
          align: 'center',
          key: 'bonus',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'bonus')
        },
        payds: {
          title: '佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        kekka: {
          title: '结果',
          align: 'center',
          key: 'kekka',
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'kekka')
        },
        l6p: {
          title: '代理',
          align: 'center',
          key: 'l6p',
          className: 'trigger-show',
          triggerShow: true,
          width: 50,
          render: (h, params) => this.ProportionRender(h, params, '6')
        },
        l5p: {
          title: '总代',
          align: 'center',
          key: 'l5p',
          className: 'trigger-show',
          triggerShow: true,
          width: 50,
          render: (h, params) => this.ProportionRender(h, params, '5')

        },
        l4p: {
          title: '股东',
          align: 'center',
          key: 'l4p',
          className: 'trigger-show',
          triggerShow: true,
          width: 50,
          render: (h, params) => this.ProportionRender(h, params, '4')
        },
        l3p: {
          title: '大股东',
          align: 'center',
          key: 'l3p',
          className: 'trigger-show',
          triggerShow: true,
          width: 50,
          render: (h, params) => this.ProportionRender(h, params, '3')
        },
        l2p: {
          title: '分公司',
          align: 'center',
          key: 'l2p',
          className: 'trigger-show',
          triggerShow: true,
          width: 50,
          render: (h, params) => this.ProportionRender(h, params, '2')
        },
        l1p: {
          title: '总公司',
          align: 'center',
          key: 'l1p',
          className: 'trigger-show',
          triggerShow: true,
          width: 50,
          render: (h, params) => this.ProportionRender(h, params, '1')
        },
        yokekka: {
          title: '您的结果',
          align: 'center',
          key: 'yokekka',
          total: true,
          minWidth: 30,
          render: (h, params) => {
            if (params.row.date !== '总计') {
              return h('div', [
                this.renderColorAmount(h, params, 'yokekka'),
                this.renderColorAmount(h, params, 'lpds')
              ])
            } else {
              if (!this.totalArr[gameid]) return
              return h('div', [
                h('p', this.NegativeColor(this.totalArr[gameid].yokekka), this.toDecimal2(this.totalArr[gameid].yokekka)),
                h('p', this.NegativeColor(this.totalArr[gameid].lpds), this.toDecimal2(this.totalArr[gameid].lpds))
              ])
            }

          }
        },
        wilo: {
          title: '下注结果',
          align: 'center',
          key: 'wilo',
          minWidth: 30,
          render: (h, params) => {
            if (params.row.date == '总计') return
            let result;
            let iscolor;
            switch (params.row.betstat) {
              case -1:
                result = '已注销'
                break;
              case 0:
                result = '准备下注'
                break;
              case 1:
                result = '下注成功'
                if (params.row.isclea == 1) {
                  switch (params.row.wilo) {
                    case -1:
                      result = '输'
                      iscolor = 'pc1'
                      break;
                    case 0:
                      result = '和'
                      break;
                    case 1:
                      result = '赢'
                      iscolor = 'pc3'
                      break;
                  }
                } else {
                  result = '未结算'
                }
                break;
            }
            return h('span', { class: iscolor }, result)
          }
        },
      }
      if (this.judgeExgame(Number(gameid))) {
        if (this.$route.path.indexOf('general-ledger') != -1) {
          delete obj.deoddsrepname
        } else {
          delete obj.gameid
        }
        delete obj.bpname
        delete obj.period
        delete obj.odds
        if (Number(gameid) == 101) {
          delete obj.bonus
          delete obj.win
        } else {
          delete obj.bonuswin
        }
      }
      if (!this.judgeExgame(Number(gameid))) {
        delete obj.win
        delete obj.bonuswin
      }
      return obj
    },
    ProportionRender (h, params, key) {
      if (params.row.date == '总计') return
      return h('div', [
        h('p', `${params.row[`l${key}p`]}%`),
        h('p', params.row[`l${key}ds`] ? `${params.row[`l${key}ds`]}%` : `0%`)
      ])
    },
    judgeExgame(gameid) { // 判斷外站遊戲
      return gameid >= 101 && gameid <= 200
    }
  }
}
